<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-cubes"></i> Stock Gudang
                </div>
                <div class="card-tools mr-0">
                    <button :disabled="isLoading" type="button" class="btn btn-primary" @click="printList">
                        <i class="fas fa-print"></i> Print
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-2">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="alert alert-primary mb-3 h4" role="alert">
                    Total Bobot : <strong class="text-nowrap">{{ summary ? formatNumber(summary.total_bobot) : 0 }} Kg</strong>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/stock-gudangs"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action-slot" slot-scope="props">
                            <button type="button" title="View" @click="view(props.rowData)" class="btn btn-link px-1"><i class="fas fa-eye"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="viewModal" size="lg" :hide-header="true" :hide-footer="true">
            <viewer :value="currentStock" @cancel="viewModal = false"></viewer>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import SearchBar from './SearchBar';
import Viewer from './Viewer';
import ExportMixin from '../../mixin/export';

export default {
    name: "stock-gudang",

    components: {
        SearchBar,
        Viewer,
    },

    mixins: [VuetableMixin, ExportMixin],

    data() {
        return {
            perPage: 10,
            currentStock: null,
            searchText: '',
            searchDate: '',
            searchGudangId: '',
            searchGradeId: '',
            viewModal: false,
            summary: null,
        }
    },

    created() {
    },

    mounted() {
        this.loadSummary();
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'grade.name',
                    title: 'Grade',
                    sortField: 'grade_name',
                },
                {
                    name: 'total_bobot',
                    title: 'Bobot Total (kg)',
                    sortField: 'total_bobot',
                    callback: 'formatNumber',
                },
                {
                    name: 'status',
                    title: 'Status',
                    sortField: 'status',
                },
                {
                    name: 'tanggal_action',
                    title: 'Tanggal Action',
                    sortField: 'tanggal_action',
                    callback: 'formatDate',
                },
                // {
                //     name: 'tanggal_selesai',
                //     title: 'Tanggal Selesai',
                //     sortField: 'tanggal_selesai',
                //     callback: 'formatDate',
                // },
                {
                    name: '__slot:action-slot',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "status", direction: "desc" },
                { field: "grade_name", direction: "asc" },
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
                date: this.searchDate,
                gudang_id: this.searchGudangId,
                grade_id: this.searchGradeId,
            };
        },
    },

    methods: {
        searchSet(search) {
            this.searchText = search.searchText;
            this.searchDate = search.searchDate;
            this.searchGudangId = search.searchGudangId;
            this.searchGradeId = search.searchGradeId;
            this.refresh();
            this.loadSummary();
        },

        searchReset() {
            this.searchText = '';
            this.searchDate = '';
            this.searchGudangId = '';
            this.searchGradeId = '';
            this.refresh();
            this.loadSummary();
        },

        view(rowData) {
            this.currentStock = Object.assign({}, rowData);
            this.viewModal = true;
        },

        printList(){
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            let params = this.convertExportParams('print');
            newIframe.src = `/stock-gudangs/list/print` + '?' + params;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function() {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
            }
        },

        loadSummary() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            axios({
                method: 'get',
                url: 'api/stock-gudangs/summary?'+self.convertParams(self.moreParams),
            })
            .then(function (response) {
                self.$Progress.finish();
                self.isLoading = false;
                self.summary = Object.assign({}, response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.vuetable-slot {
    padding-bottom: 0.3rem !important;
}
</style>
